export const sortShips = [
  {
    title: 'По реновации',
    mode: 'restoration_date',
    type: 'DESC',
  },
  {
    title: 'По году постройки',
    mode: 'construction_date',
    type: 'DESC',
  },
];
